/**
 * Optimise une URL d'image Cloudinary (redimensionnement, format et qualité automatiques).
 * Les autres URLs sont renvoyées telles quelles.
 */
export function optimizeImage(url, width = 480) {
  if (!url) return url;

  if (
    url.includes('res.cloudinary.com') &&
    url.includes('/upload/') &&
    !url.includes('/upload/w_')
  ) {
    return url.replace('/upload/', `/upload/w_${width},c_fill,f_auto,q_auto/`);
  }

  return url;
}
